export default "__VITE_ASSET__9a8572eb__"